import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BackButtonArrow,
  PageHeaderBackground,
} from '@leagueplatform/web-common-components';
import { Box, HeadingText, StackLayout } from '@leagueplatform/genesis-core';
import { AuthorizationStatus } from 'utils/get-translated-status-label';
import { AuthorizationStatusBar } from './authorization-status-banner.component';

export interface AuthorizationCardProps {
  heading: string;
  status: AuthorizationStatus;
}

const statusColors: Record<AuthorizationStatus, string> = {
  approved: '#D5F2E7',
  medReview: '#D9F3F3',
  inProgress: '#FAE8D6',
  denied: '#F9DEE3',
  closed: '#F0F0F0',
};

export const AuthorizationDetailsHeader: React.FC<AuthorizationCardProps> = ({
  heading,
  status,
}) => {
  const navigate = useNavigate();
  const backgroundColor = statusColors[status];

  return (
    <PageHeaderBackground
      height="154px"
      pageHeaderBackgroundHeight="154px"
      css={{
        '&:before': {
          backgroundColor: `${backgroundColor} !important`,
        },
      }}
    >
      <Box css={{ width: '100%' }}>
        <StackLayout
          orientation={{ '@initial': 'horizontal' }}
          css={{ alignItems: 'baseline' }}
        >
          <BackButtonArrow
            fontSize="heading3"
            color="onSurface.text.primary"
            marginRight="one"
            marginY="half"
            justifyContent="initial"
            onClick={() => {
              navigate(-1);
            }}
          />
          <HeadingText
            level="1"
            size={{ '@initial': 'xxl', '@mobile': 'lg' }}
            css={{ marginBlock: '$one $one' }}
          >
            {heading}
          </HeadingText>
        </StackLayout>
        <StackLayout
          css={{
            flex: 1,
            paddingLeft: '50px',
          }}
        >
          <AuthorizationStatusBar status={status} />
        </StackLayout>
      </Box>
    </PageHeaderBackground>
  );
};
